import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@/context/ThemeProvider';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { SeoJsonLd } from '@/components/common/SeoJsonLd';
import { HomePage } from '@/pages/HomePage';

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <a className="skip-link" href="#main-content">
          Skip to content
        </a>
        <SeoJsonLd />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
